var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCosmetics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Make-Up-Brush-Set--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Make Up Brush Set Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.5A2.5 2.5 0 0 0 21.5 0h-19A2.5 2.5 0 0 0 0 2.5v19A2.5 2.5 0 0 0 2.5 24h19a2.5 2.5 0 0 0 2.5 -2.5ZM6.5 20a1.5 1.5 0 0 1 -3 0v-9.5A0.5 0.5 0 0 1 4 10h2a0.5 0.5 0 0 1 0.5 0.5Zm0.11 -11.84a0.5 0.5 0 0 1 -0.47 0.34H3.86a0.5 0.5 0 0 1 -0.47 -0.34L2 4c0 -0.65 1.5 -1.48 3 -1.48S8 3.35 8 4Zm7.89 12.51a0.83 0.83 0 0 1 -0.83 0.83h-2.84a0.83 0.83 0 0 1 -0.83 -0.83v-2.84a0.83 0.83 0 0 1 0.83 -0.83h2.84a0.83 0.83 0 0 1 0.83 0.83Zm0 -7a0.83 0.83 0 0 1 -0.83 0.83h-2.84a0.83 0.83 0 0 1 -0.83 -0.83v-2.84a0.83 0.83 0 0 1 0.83 -0.83h2.84a0.83 0.83 0 0 1 0.83 0.83Zm0 -7a0.83 0.83 0 0 1 -0.83 0.83h-2.84a0.83 0.83 0 0 1 -0.83 -0.83V3.83a0.83 0.83 0 0 1 0.83 -0.83h2.84a0.83 0.83 0 0 1 0.83 0.83Zm7 14a0.83 0.83 0 0 1 -0.83 0.83h-2.84a0.83 0.83 0 0 1 -0.83 -0.83v-2.84a0.83 0.83 0 0 1 0.83 -0.83h2.84a0.83 0.83 0 0 1 0.83 0.83Zm0 -7a0.83 0.83 0 0 1 -0.83 0.83h-2.84a0.83 0.83 0 0 1 -0.83 -0.83v-2.84a0.83 0.83 0 0 1 0.83 -0.83h2.84a0.83 0.83 0 0 1 0.83 0.83Zm0 -7a0.83 0.83 0 0 1 -0.83 0.83h-2.84a0.83 0.83 0 0 1 -0.83 -0.83V3.83a0.83 0.83 0 0 1 0.83 -0.83h2.84a0.83 0.83 0 0 1 0.83 0.83Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCosmetics);
export default ForwardRef;